module.exports = __webpack_public_path__ + "static/img/Knowledge Graph.028bdc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/technology/Knowledge Graph.jpg
// module id = a2pz
// module chunks = 1